var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _mask, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#D4D4D4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0325,
    y: 24.677,
    width: 23.9446,
    height: 11.5,
    rx: 1.10526,
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8333,
    y: 19.9641,
    width: 0.908587,
    height: 4.19945,
    rx: 0.454294,
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.259,
    y: 19.9641,
    width: 0.908587,
    height: 4.19945,
    rx: 0.454294,
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.814 16.3054C25.814 17.4651 24.8739 18.4052 23.7142 18.4052C22.5546 18.4052 21.6145 17.4651 21.6145 16.3054C21.6145 15.6885 21.8738 14.5043 22.3087 13.4688C22.5248 12.954 22.7741 12.5013 23.0372 12.1838C23.3088 11.8561 23.5394 11.7376 23.7142 11.7376C23.8891 11.7376 24.1197 11.8561 24.3913 12.1838C24.6544 12.5013 24.9036 12.954 25.1198 13.4688C25.5546 14.5043 25.814 15.6885 25.814 16.3054Z",
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3921 16.3054C32.3921 17.4651 31.452 18.4052 30.2924 18.4052C29.1327 18.4052 28.1926 17.4651 28.1926 16.3054C28.1926 15.6885 28.452 14.5043 28.8868 13.4688C29.103 12.954 29.3522 12.5013 29.6153 12.1838C29.8869 11.8561 30.1175 11.7376 30.2924 11.7376C30.4672 11.7376 30.6978 11.8561 30.9694 12.1838C31.2325 12.5013 31.4818 12.954 31.6979 13.4688C32.1328 14.5043 32.3921 15.6885 32.3921 16.3054Z",
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4844 30.0649C15.7586 30.6134 15.8135 31.7103 17.1298 31.7103C18.7752 31.7103 18.7752 29.2422 20.4207 29.2422C22.0661 29.2422 22.0661 31.7103 23.7115 31.7103C25.357 31.7103 26.1797 29.2422 27.0024 29.2422C27.8251 29.2422 27.0024 31.7103 29.4705 31.7103C31.9387 31.7103 31.116 29.2422 32.7614 29.2422C34.4068 29.2422 33.5841 31.7103 36.0522 31.7103C38.5204 31.7103 36.875 29.2422 38.5204 29.2422",
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_13443_61014",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.3711,
    y: 35.8262,
    width: 31.2632,
    height: 4.93629,
    rx: 0.368421
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3711,
    y: 35.8262,
    width: 31.2632,
    height: 4.93629,
    rx: 0.368421,
    stroke: "currentColor",
    strokeWidth: 1.47368,
    mask: "url(#path-8-inside-1_13443_61014)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.824cbd86718cd5b46f5228f1aafeb1d5.svg";
export { ForwardRef as ReactComponent };